module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown is-hoverable"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('a', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('div', {
    staticClass: "dropdown-item"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-632607d3"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown.vue
// module id = 1050
// module chunks = 0